export const cocoFontFamily = '"OptimisticDisplay", Arial, sans-serif'
